import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from '../ui/components/navigation/Navigation';
import Footer from '../ui/components/footer/Footer';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import ChatBot from '../features/chat/ChatBot';
import BottomNav from '../ui/components/bottom-nav/BottomNav';
import './MainLayout.css';

const MainLayout = () => {
   const [isMobile, setIsMobile] = useState(false);

   useEffect(() => {
      // Check if device is mobile
      const checkIsMobile = () => {
         setIsMobile(window.innerWidth <= 768);
      };

      // Initial check
      checkIsMobile();

      // Add event listener for resize
      window.addEventListener('resize', checkIsMobile);

      // Cleanup listener on unmount
      return () => {
         window.removeEventListener('resize', checkIsMobile);
      };
   }, []);

   // Decode JWT to get userType
   const jwt = Cookies.get("jwt");
   const decoded = jwt ? jwtDecode(jwt) : null;
   const userType = decoded?.userType;

   // ROUTES where we want a CLEAN layout (no global footer/nav)
   // Business Dashboard needs clean layout (has sidebar), Customer Dashboard needs global nav
   const currentPath = window.location.pathname;
   const isCleanLayout =
      currentPath.includes('/restaurant-editable') ||
      currentPath.includes('/food-template-1') ||
      currentPath.includes('/fashion-editable') ||
      (currentPath.includes('/dashboard') && userType !== 'customer');

   // Hide footer on specific pages OR if it's a clean layout
   const shouldShowFooter = !isMobile && currentPath === '/' && !isCleanLayout;

   return (
      <div className="app-layout">
         {!isCleanLayout && <Navigation />}
         <main>
            <Outlet />
         </main>
         {/* Show footer only on desktop home page */}
         {shouldShowFooter && <Footer />}

         {/* Show chatbot only on desktop (Temporarily disabled) */}
         {/* {!isMobile && <ChatBot />} */}

         {/* Show bottom navigation only on mobile AND not on clean layouts AND only when logged in */}
         {isMobile && jwt && !isCleanLayout && <BottomNav />}
      </div>
   );
};

export default MainLayout;